import styles from "./requiredMark.module.css";

/** Pass as `<Form className>` to show the star after the label, before any tooltip icon. */
const requiredMarkClassName = styles.requiredMark;

export default requiredMarkClassName;
